import {
  pgTable,
  text,
  serial,
  timestamp,
  integer,
  numeric,
} from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";
import { usersTable } from "./users";

export const sellerLeadsTable = pgTable("seller_leads", {
  id: serial("id").primaryKey(),
  name: text("name").notNull(),
  phone: text("phone").notNull(),
  email: text("email").notNull(),
  propertyArea: text("property_area").notNull(),
  buildingProject: text("building_project"),
  propertyType: text("property_type").notNull(),
  bedrooms: text("bedrooms"),
  askingPrice: numeric("asking_price").notNull(),
  mortgageOutstanding: numeric("mortgage_outstanding"),
  urgencyReason: text("urgency_reason").notNull(),
  timelineToSell: text("timeline_to_sell").notNull(),
  additionalNotes: text("additional_notes"),
  photoUrls: text("photo_urls"),
  status: text("status", {
    enum: ["new", "contacted", "valuation", "assigned", "active", "closed", "rejected"],
  })
    .notNull()
    .default("new"),
  paymentStatus: text("payment_status", {
    enum: ["unpaid", "pending", "paid", "failed"],
  })
    .notNull()
    .default("unpaid"),
  paymentPlan: text("payment_plan", {
    enum: ["urgent_seller", "concierge_sale"],
  }),
  assignedAgentId: integer("assigned_agent_id").references(() => usersTable.id),
  adminNotes: text("admin_notes"),
  agentNotes: text("agent_notes"),
  // AI qualification fields
  aiLeadTemperature: text("ai_lead_temperature"),
  aiUrgencyScore: integer("ai_urgency_score"),
  aiLikelyMotivation: text("ai_likely_motivation"),
  aiSuggestedAgentScript: text("ai_suggested_agent_script"),
  aiRecommendedNextStep: text("ai_recommended_next_step"),
  createdAt: timestamp("created_at", { withTimezone: true })
    .notNull()
    .defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }),
});

export const insertSellerLeadSchema = createInsertSchema(
  sellerLeadsTable
).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertSellerLead = z.infer<typeof insertSellerLeadSchema>;
export type SellerLead = typeof sellerLeadsTable.$inferSelect;
